import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { interconsultaMapperBackend } from '../helpers'; 
import { showPdf } from '../../../shared/helpers/files';


const getAll = async ( params = {} ) => {

  const { 
    search, page, pageSize, paciente, doctor, 
    tipo, establecimiento, estadoInterconsulta 
  } = params;

  const query = `
    query GetInterconsultas(
      $page: Int
      $pageSize: Int
      $establecimiento: String,
      $estadoInterconsulta: String
      $paciente: ID
      $doctor: ID
      $tipo: String
    ) {
      getInterconsultas(
        page:$page
        pageSize:$pageSize
        establecimiento:$establecimiento
        estadoInterconsulta:$estadoInterconsulta
        paciente:$paciente
        tipo:$tipo
        doctor:$doctor
      ) {
        total
        status
        message
        interconsultas {
          id
          token
          fechaInterconsulta
          esUrgente
          servicio
          motivo
          cuadroClinico
          resultadoExamenes
          planTerapeutico
          diagnosticos
          estadoInterconsulta
          tipo
          atencionMedica {
            id
            token
          }
          especialidad {
            id
            descripcion
          }
        }
      }
    }
  `;

  const variables = {
    search,
    page,
    establecimiento,
    estadoInterconsulta,
    paciente,
    doctor,
    tipo,
    pageSize
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    const response2 = response.data.data.getInterconsultas;

    if( response2.status !== 200 ) return null;
    if( !response2.interconsultas ) return null;
    const data = { ...response2 }

    return data;

  }catch(error){
    console.log(error);
    return error;
  }
}


const getByToken = async ( token ) => {

  if( !token ) return null;

  const query = `
    query GetInterconsultas($token:String!) {
      getInterconsultas(tokenInterconsulta:$token) {
        total
        status
        message
        interconsultas {
          id
          token
          fechaInterconsulta
          esUrgente
          servicio
          motivo
          cuadroClinico
          resultadoExamenes
          planTerapeutico
          diagnosticos
          estadoInterconsulta
          tipo
          atencionMedica {
            id
            token
          }
          especialidad {
            id
            descripcion
          }
        }
      }
    }
  `;

  const variables = { token };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    const response2 = response.data.data.getInterconsultas;
    
    if( response2.status !== 200 ) return null;
    if( !response2.interconsultas ) return null;
    
    const data = response2.interconsultas[0];
    return data;
    
  }catch(error){
    console.log('error obtener interconsulta by token', error);
    return error;
  }

}


const getByAtencionId = async ( atencionId ) => {

  const query = `
    query GetInterconsultas($atencionMedicaId: ID!) {
      getInterconsultas(atencionMedicaId: $atencionMedicaId) {
        total
        status
        message
        interconsultas {
          id
          token
          estadoInterconsulta
          especialidad {
            id
            descripcion
          }
        }
      }
    }
  `;

  const variables = { atencionMedicaId: atencionId };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    const response2 = response.data.data.getInterconsultas;
    
    if( response2.status !== 200 ) return null;
    if( !response2.interconsultas ) return null;
    
    const data = response2.interconsultas;
    return data;
    
  }catch(error){
    console.log('error obtener interconsulta by atencion id', error);
    return error;
  }
}


const getUrlView007 = async (tokenInterconsulta) => {

  const query = `
    query MyQuery {
      generateForm007(tokenInterconsulta: "${tokenInterconsulta}") {
        pdfBase64List
      }
    }
  `;
        
  try {
    const response = await axios.post(rutas.axios + "api", { query });
    if (response.status !== 200) return null;

    const response2 = response.data.data.generateForm007;
    if (!response2) return null;

    const dataPdf = response2.pdfBase64List;
    if (!dataPdf) return null;

    const tempUrl = showPdf(dataPdf);
    return tempUrl;

  } catch (error) {
    console.error('error obtener url view 007', error);
    return null;
  }
}


const registrar = async ( params ) => {

  // console.log('params', params);
  
  const { 
    idAtencion, tipo, 
    fechaInterconsulta, especialidad, 
    cuadroClinico, planTerapeutico, diagnosticos
  } = params;

  if (!idAtencion) {
    console.error('No se recibió el ID de la atención.');
    return null;
  }

  if (!tipo) {
    console.error('No se recibió el tipo de interconsulta.');
    return null;
  }

  const query = `
    mutation CrearInterconsulta(
      $atencionMedica    : ID!
      $cuadroClinico     : String
      $fechaInterconsulta: String
      $esUrgente         : String
      $servicio          : String
      $especialidad      : ID
      $motivo            : String
      $resultadoExamenes : String
      $planTerapeutico   : String
      $diagnosticos      : String
      $estado            : String
      $tipo              : String
    ) {
      crearInterconsulta(
        atencionMedica     : $atencionMedica
        cuadroClinico      : $cuadroClinico
        fechaInterconsulta : $fechaInterconsulta
        esUrgente          : $esUrgente
        servicio           : $servicio
        especialidad       : $especialidad
        motivo             : $motivo
        resultadoExamenes  : $resultadoExamenes
        planTerapeutico    : $planTerapeutico
        diagnosticos       : $diagnosticos
        estado             : $estado
        tipo               : $tipo
      ) {
        status
        message
        interconsulta{
          id, token
        }
      }
    }
  `;

  const variables = {
    atencionMedica: idAtencion,
    especialidad,
    fechaInterconsulta: fechaInterconsulta || '',
    cuadroClinico     : cuadroClinico      || '',
    planTerapeutico   : planTerapeutico    || '',
    diagnosticos      : diagnosticos       || '',
    tipo,
    estado:'99'
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(!response) return null;

    const response2 = response.data.data.crearInterconsulta;
    if( response2.status !== 200 ) return null;

    const data = response2.interconsulta;
    return data;

  }catch(error){
    console.log('error al registrar la interconsulta', error);
    return null;
  }


}


const update = async (dataInterconsulta) =>{

  if(!dataInterconsulta.token){
    console.error('token no enviado');
    return null;
  }

  const query = `
    mutation ActualizarInterconsulta(
      $tokenInterconsulta:String!
      $fechaInterconsulta:String
      $servicio:String
      $especialidad:ID
      $motivo:String
      $esUrgente:String
      $cuadroClinico:String
      $resultadoExamenes:String
      $criterioClinico:String
      $planDiagnostico:String
      $planTerapeutico:String
      $diagnosticos:String
    ) {
      actualizarInterconsulta(
        tokenInterconsulta: $tokenInterconsulta,
        fechaInterconsulta:$fechaInterconsulta
        servicio:$servicio
        especialidad:$especialidad
        motivo:$motivo
        esUrgente:$esUrgente
        cuadroClinico:$cuadroClinico
        resultadoExamenes:$resultadoExamenes
        criterioClinico:$criterioClinico
        planDiagnostico:$planDiagnostico
        planTerapeutico:$planTerapeutico
        diagnosticos:$diagnosticos
      ) {
        status
        message
        interconsulta {
          id, token
        }
      }
    }
  `;

  const variables = interconsultaMapperBackend(dataInterconsulta);

  try{

    const response = await axios.post(rutas.axios + "api", { query, variables });
    const response2 = response.data.data.actualizarInterconsulta;

    if( response2.status !== 200 ) return null;
    const data = response2.interconsulta;
    return data;

  }catch(error){
    console.log(error);
    return null;
  }
  
}



const deleteByToken = async ( token ) => {

  if(!token){
    console.error('token no enviado');
    return null;
  }

  const query = `
    mutation ActualizarInterconsulta(
      $tokenInterconsulta: String!
      $estado: String
    ) {
      actualizarInterconsulta(
        tokenInterconsulta: $tokenInterconsulta
        estado: $estado
      ) {
        status
        message
        interconsulta {
          id
          token
        }
      }
    }
  `;

  const variables = {
    tokenInterconsulta: token,
    estado: '0'
  };

  try{
    
    const response = await axios.post(rutas.axios + "api", { query, variables });
    const response2 = response.data.data.actualizarInterconsulta;
    if( response2.status !== 200 ) return null;
    const data = response2.interconsulta;
    return data;

  }catch(error){
    console.log(error);
    return null;
  }
}


export const interconsultaService = {
  registrar,
  getByToken,
  getAll,
  getUrlView007,
  update,
  deleteByToken,
  getByAtencionId
}